import { CoverageIdEnum, DateService, PolicyProductIdEnum, PurchasedProductInterface } from 'outshared-lib';
import { CoverageInput } from '../classes';

export class MostPopularUtility {

    public isMostPopularCar(purchasedProduct: PurchasedProductInterface, coverageInput: CoverageInput): boolean {
        const isCar = purchasedProduct.productId === PolicyProductIdEnum.Car;
        const ageCar = this.getAgeCar(purchasedProduct.product?.car?.buildDate);
        const catalogValueAmount = Number(purchasedProduct.product?.car?.catalogValueAmount);

        if (!isCar) {
            return false;
        }

        return this.isMostPopular(coverageInput.id, ageCar, catalogValueAmount);
    }

    private getAgeCar(buildDate: string): number {
        const dateService = new DateService();

        if (!buildDate) {
            return 0;
        }

        return (dateService.year() - Number(this.stripYear(buildDate)));
    }

    private stripYear(date: string): string {
        return date.substring(0, 4);
    }

    private isMostPopular(coverageId: CoverageIdEnum, ageCar: number, catalogValueAmount: number): boolean {
        switch (coverageId) {
            case CoverageIdEnum.CarAllrisk:
                if (ageCar < 7) {
                    return true;
                }
                if ((ageCar === 7 || ageCar === 8) && catalogValueAmount >= 15001) {
                    return true;
                }
                if (ageCar === 9 && (catalogValueAmount >= 35001 && catalogValueAmount <= 45000)) {
                    return true;
                }
                break;

            case CoverageIdEnum.CarLimitedCascoExtra:
                if ((ageCar === 7 || ageCar === 8) && catalogValueAmount <= 15000) {
                    return true;
                }
                if ((ageCar >= 10 && ageCar <= 13) && catalogValueAmount >= 35001) {
                    return true;
                }
                if (ageCar === 9 && catalogValueAmount >= 45001) {
                    return true;
                }
                break;

            case CoverageIdEnum.CarLimitedCasco:
                if ((ageCar >= 9 && ageCar <= 13) && catalogValueAmount <= 35000) {
                    return true;
                }
                if ((ageCar >= 14 && ageCar <= 15) && catalogValueAmount >= 45001) {
                    return true;
                }
                break;

            case CoverageIdEnum.CarLegalLiability:
                if ((ageCar >= 14 && ageCar <= 15) && catalogValueAmount <= 45000) {
                    return true;
                }
                if (ageCar >= 16) {
                    return true;
                }
                break;
        }

        return false;
    }
}
